import { observer } from "mobx-react-lite";
import { MdsVirtualizedItemList } from "@/design-system/components/item-list";
import { CollectionsListPageListEmpty } from "@/pages/collections/components/CollectionsListPageListEmpty";
import { useTabPageStore } from "@/hooks/useTabPageStore";

export const CollectionsListPageList = observer(() => {
  const page = useTabPageStore("collectionsListPage");
  page.listState.useListStateEffects();

  if (page.shouldShowEmptyState) {
    return <CollectionsListPageListEmpty />;
  }

  return (
    <>
      <MdsVirtualizedItemList
        rows={page.itemRows}
        listState={page.listState}
        loading={page.isLoading}
      />
      {page.listState.multiSelectUi}
    </>
  );
});
